module.exports = new __parcel__URL__("bg_main_image.89deacdd.jpg").toString();